import { outlinedInputClasses } from '@mui/material';
import type { Theme } from '@mui/material';

export const muiOutlinedInputOverrides = {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => {
			return {
				boxSizing: 'border-box !important',
				[`& .${outlinedInputClasses.input}`]: {
					backgroundColor: theme.palette.background.paper,
					height: '30px !important',
					padding: '4px 10px',
					boxSizing: 'border-box',
					lineHeight: '22px !important',
					'&.MuiInputBase-readOnly': {
						backgroundColor: 'inherit',
						color: 'inherit',
					},
				},
				'&:hover': {
					[`& .${outlinedInputClasses.notchedOutline}`]: {
						border: '1px solid hsla(199,100%,50%,.25)',
						boxShadow: '0 0 0 1px hsla(199,100%,50%,.75)',
						borderRadius: theme.shape.borderRadius,
					},
				},
				[`& .${outlinedInputClasses.notchedOutline}`]: {
					width: '100%',
					boxSizing: 'border-box',
					top: 0,
					legend: {
						display: 'none',
					},
				},
			};
		},
	},
};
